function initSingleCheckboxGroups() {
	const checkboxes = document.querySelectorAll('[data-checkbox-group]');
	console.info(checkboxes);
	checkboxes.forEach((checkbox) => {
		checkbox.addEventListener('change', function () {
			const group = this.dataset.checkboxGroup;

			if (this.checked) {
				document.querySelectorAll(`[data-checkbox-group="${group}"]`).forEach((b) => {
					if (b !== this) b.checked = false;
				});
			}
		});
	});
}

document.addEventListener('DOMContentLoaded', initSingleCheckboxGroups);
